export default import.meta.ROLLUP_FILE_URL_SY5VEO_8ROmQObMQjNRklQ